



















































































import { Component, Vue } from "vue-property-decorator";
import { Button, Field, Uploader, Dialog, Toast } from "vant";
import CustomSelect from "./components/CustomSelect.vue";
import lrz from "lrz";

@Component({
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    customSelect: CustomSelect,
    [Dialog.Component.name]: Dialog.Component
  }
})
export default class CredentialsUpload extends Vue {
  currency: any = "";
  amount = "";
  fileList: any[] = [];
  fileUrlList: any[] = [];
  uploadLoading: any = null;
  MAX_IMG_AMOUNT = 6;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get currencyType() {
    return [
      {
        text: this.$t("funds.currencyText[1]"),
        value: "HKD"
      },
      {
        text: this.$t("funds.currencyText[0]"),
        value: "USD"
      },
      {
        text: this.$t("funds.credential.domText[2]"),
        value: "CNH"
      }
    ];
  }

  get isDisabledSubmit() {
    return !(this.amount && this.fileUrlList.length);
  }

  created() {
    this.currency = this.$t("funds.currencyText[0]");
  }

  clearNoNum() {
    this.amount = this.amount.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
    this.amount = this.amount.replace(/^\./g, ""); //验证第一个字符是数字
    this.amount = this.amount.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
    this.amount = this.amount
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");
    this.amount = this.amount.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  }

  handleUploadCredentials(file: any) {
    this.uploadLoading = Toast.loading({
      duration: 0,
      forbidClick: true,
      loadingType: "spinner",
      message: `${this.$t("funds.credential.domText[4]")}...`
    });
    return new Promise((resolve, reject) => {
      if (Array.isArray(file)) {
        const params = new FormData();
        for (let i = 0, len = file.length; i < len; i++) {
          params.append(`file[${i}]`, file[i]);
        }
        params.append("put_dir", "gygjqh_money");
        (this as any).$apis
          .myUploadFileMulti(params)
          .then(res => {
            this.uploadLoading && this.uploadLoading.clear();
            res.forEach(item => {
              if (
                this.fileUrlList &&
                this.fileUrlList.length < this.MAX_IMG_AMOUNT
              ) {
                this.fileUrlList.push(item.content);
              }
            });
            resolve();
          })
          .catch(() => {
            this.uploadLoading && this.uploadLoading.clear();
            reject();
          });
      } else {
        this.handleUploadSingleFile(file, resolve, reject);
      }
    });
  }

  uploadFileSingle(params, resolve, reject) {
    (this as any).$apis
      .myUploadFile(params)
      .then(res => {
        this.uploadLoading && this.uploadLoading.clear();
        if (this.fileUrlList && this.fileUrlList.length < this.MAX_IMG_AMOUNT) {
          this.fileUrlList.push(res.content);
        }
        resolve();
      })
      .catch(() => {
        this.uploadLoading && this.uploadLoading.clear();
        reject();
      });
  }

  handleUploadSingleFile(file, resolve, reject) {
    const params = new FormData();
    if (file.type === "image/gif") {
      params.append(`file`, file);
      params.append("put_dir", "gygjqh_money");
      this.uploadFileSingle(params, resolve, reject);
    } else {
      lrz(file, { quality: 0.5 }).then(compressRes => {
        params.append(`file`, compressRes.file);
        params.append("put_dir", "gygjqh_money");
        this.uploadFileSingle(params, resolve, reject);
      });
    }
  }

  handleDeleteUploadImg(file) {
    for (let i = 0, len = this.fileList.length; i < len; i++) {
      if (this.fileList[i].content === file.content) {
        this.fileUrlList.splice(i, 1);
        this.fileList.splice(i, 1);
        return true;
      }
    }
  }

  handleNextStep() {
    const params = {
      remittance_bank_id: this.$route.query.id,
      remittance_currency: this.currency,
      amount: this.amount,
      voucher: this.fileUrlList.join(","),
      // funds_account_type: this.$route.query.type
      funds_account_type: this.$route.query.account_type,
      account_no: this.$route.query.account_no
    };
    // this.$toast.loading();
    (this as any).$apis
      .submitTransferInto(params)
      .then(() => {
        this.$dialog
          .alert({
            title: `${this.$t("funds.credential.domText[5]")}`,
            message: `${this.$t("funds.credential.domText[6]")}`,
            confirmButtonText: `${this.$t("funds.credential.domText[7]")}`,
            className: this.bgColor == 'black-theme' ? 'black-theme-dialog' : '',
          })
          .then(() => {
            switch (this.$route.query.from) {
              case "inland":
                this.$router.go(-3);
                break;
              case "hk":
                this.$router.go(-4);
                break;
              default:
                this.$router.push({ name: "funds-management" });
            }
          });
      })
      .catch(e => {
        
      });
  }

  beforeDestroy() {
    this.uploadLoading && this.uploadLoading.clear();
  }
}
